import React, { useState, useEffect, useRef } from 'react';
import PaginationComponent from '../../pagination';
import { FaFilter } from "react-icons/fa";
import { Link } from 'react-router-dom';
import Select from "react-select";
import { IoEye } from "react-icons/io5";
import { LoadingWait } from '../../../CommonComponents/LoadingWait';

function Cart() {

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');

    // PAGINATION LOGIC
    const [currentPage, setCurrentPage] = useState(1);
    const resultPerPage = [
        { value: 10, label: "10 items per page" },
        { value: 20, label: "20 items per page" },
        { value: 50, label: "50 items per page" },
        { value: 100, label: "100 items per page" },
        { value: 200, label: "200 items per page" },
    ];
    const [lengthOfPage, setLengthOfPage] = useState(() => {
        return JSON.parse(sessionStorage.getItem("cartPerPage")) || resultPerPage[2]
    });

    useEffect(() => {
        sessionStorage.setItem("cartPerPage", JSON.stringify(lengthOfPage));
    }, [lengthOfPage]);

    // Pagination logic
    const itemsPerPage = lengthOfPage?.value; // Show 10 items per page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const [list, setList] = useState([]);
    const [filterList, setFilterList] = useState([...list]);
    const [isLoading, setIsLoading] = useState(false);
    const items = async () => {
        setIsLoading(true);
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/order/getCartList`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setList(getRes.responsePacket);
                setFilterList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'error in cart detail')
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        items();
    }, []);

    const HRD = (time) => {
        const date = new Date(time);
        const options = {
            day: 'numeric',    // 5
            month: 'numeric',    // Dec
            year: 'numeric',   // 2024
            hour: '2-digit',   // 10
            minute: '2-digit',
            hour12: true
        };
        const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
        return formattedDate
    };

    const [inputSearch, setInputSearch] = useState();
    const handleSearch = (e) => {
        const searchValue = e.target.value.toLowerCase();
        setInputSearch(searchValue);

        const res = list.filter((itm) => {
            const firstName = itm.customerDetail?.userCustomerFirstName?.toLowerCase() || "";
            const lastName = itm.customerDetail?.userCustomerLastName?.toLowerCase() || "";
            const mobile = itm.customerDetail?.userCustomerMobile?.toString() || "";
            const orderTotal = itm.orderTotal?.toString() || "";

            return (
                firstName.includes(searchValue) ||
                lastName.includes(searchValue) ||
                orderTotal.includes(searchValue) ||
                mobile.includes(searchValue)
            );
        });

        setFilterList(res);
        setCurrentPage(1);
    };

    // FILTER LIST
    const [sortShow, setSortShow] = useState(false);

    // HANDLE OUTSIDE CLICK
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setSortShow(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);

    // SORT METHOD
    const sort = [
        { id: 1, title: "A-Z" },
        { id: 2, title: "Z-A" },
        { id: 3, title: "Latest Added" },
        { id: 4, title: "Oldest Added" },
        { id: 7, title: "High to low price" },
        { id: 8, title: "low to high price" },
    ];

    const [sortBy, setSortBy] = useState();

    const handleSort = async (by) => {
        setSortBy(by);
        if (by === 'A-Z') {
            const sortAz = [...list].sort((a, b) => a.customerDetail?.userCustomerFirstName?.localeCompare(b.title));
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setInputSearch('');
        } else if (by === "Z-A") {
            const sortAz = [...list].sort((a, b) => b.customerDetail?.userCustomerFirstName?.localeCompare(a.title));
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setInputSearch('');
        } else if (by === 'Latest Added') {
            const sortAz = [...list].sort((a, b) => new Date(b.createdAtTimeStamp).getTime() - new Date(a.createdAtTimeStamp).getTime());
            setFilterList(sortAz);
            setCurrentPage(1);
            setInputSearch('');
            setSortShow(false);
        } else if (by === 'Oldest Added') {
            const sortAz = [...list].sort((a, b) => new Date(a.createdAtTimeStamp).getTime() - new Date(b.createdAtTimeStamp).getTime());
            setFilterList(sortAz);
            setCurrentPage(1);
            setInputSearch('');
            setSortShow(false);
        } else if (by === 'High to low price') {
            const sortAz = [...list].sort((a, b) => b.orderTotal - a.orderTotal);
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setInputSearch('');
        } else if (by === 'low to high price') {
            const sortAz = [...list].sort((a, b) => a.orderTotal - b.orderTotal);
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setInputSearch('');

        } else if (by === "Remove Filter") {
            setFilterList(list);
            setCurrentPage(1);
            setSortShow(false);
            setInputSearch('');
            setSortBy();
        }
    };

    return (
        <>
            <div className="category" style={{ display: "flex", justifyContent: "center" }}>
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Cart</h4>
                        </div>
                        <div className="category-btn">
                            <Select
                                defaultValue={resultPerPage[2]}
                                closeMenuOnSelect={true}
                                name="colors"
                                options={resultPerPage}
                                value={lengthOfPage}
                                onChange={(e) => { setLengthOfPage(e); setCurrentPage(1) }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </div>
                    </div>
                    <hr />

                    <div className="category-filter">
                        <div className="filter">
                            <div className="btn-1">
                                <button onClick={() => setSortShow(!sortShow)}><FaFilter /></button>
                                {
                                    sortShow && <div className="sort-list" style={{ width: "338%" }} ref={ref}>
                                        {
                                            sort.map((item) => {
                                                return (
                                                    <>
                                                        <div className="list-item" id="sort" onClick={() => handleSort(item.title)}>
                                                            <div className="outer-c" >
                                                                <div className="inner-c" style={{ backgroundColor: sortBy === item.title ? "black" : "" }}></div>
                                                            </div>
                                                            <label for={item.id}>{item.title}</label>
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }
                                        <div className="list-item" id="sort" onClick={() => handleSort("Remove Filter")}>

                                            <label for="Remove Filter">Remove Filter</label>
                                        </div>
                                    </div>
                                }

                            </div>

                        </div>
                        <div className="search">
                            <h4>Search:</h4>
                            <input type="text" value={inputSearch} onChange={(e) => handleSearch(e)} placeholder="Search...." className="input" />
                        </div>
                    </div>

                </div>
            </div>



            <div className="menu-table-container sticky-container-order">
                <div className="order-list ">
                    <div className="order-list-header display-cat-list">
                        <div className="tittle">S.No.</div>
                        <div className='tittle'>Customer</div>
                        <div className="tittle">Created At</div>
                        <div className='tittle'>Items</div>
                        <div className='tittle'>Cart Total</div>
                        <div className='tittle'>View</div>
                    </div>
                </div>
            </div>
            <div className="menu-table-container">
                <div className="order-list ">
                    {/* <div className="order-list-header display-cat-list sticky-container">
                        <div className="tittle">S.No.</div>
                        <div className='tittle'>Customer</div>
                        <div className="tittle">Created At</div>
                        <div className='tittle'>Items</div>
                        <div className='tittle'>Cart Total</div>
                        <div className='tittle'>View</div>
                    </div> */}

                    {
                        filterList?.slice(indexOfFirstItem, indexOfLastItem).map((item, index) => {
                            return (
                                <>
                                    <div key={item} className='order-list-row display-cat-list'>
                                        <div className="tittle">{indexOfFirstItem + index + 1}</div>
                                        <div className='tittle'>{item?.customerDetail?.userCustomerFirstName} {item?.customerDetail?.userCustomerLastName} <br /> <span>  {item?.customerDetail?.userCustomerMobile}</span></div>
                                        <div className='tittle'>{HRD(item.createdAtTimeStamp)}</div>
                                        <div className='tittle'>{item.itemDetailList?.length}</div>
                                        <div className="tittle">{item.orderTotal}</div>
                                        <Link to='/admin/cartDetail' className="tittle" style={{ color: "black", fontSize: "20px" }} state={item.uuid}>
                                            <span className="tittle"><IoEye /></span>
                                        </Link>
                                    </div>
                                </>
                            )
                        })
                    }
                    <div className="pagination">
                        <span>Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filterList?.length)} of {filterList?.length} entries</span>
                        <span className="pagination-buttons">
                            <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalItem={filterList?.length} lengthOfPage={lengthOfPage} />
                        </span>
                    </div>
                </div>
            </div>
            <LoadingWait isTrue={isLoading} />
        </>
    )
}
export default Cart;